// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Account-__user-password__wrapper--b91v1","field":"src-components-Account-__user-password__field--2FFRC","title":"src-components-Account-__user-password__title--15s9V","username":"src-components-Account-__user-password__username--3rp6n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Account/user-password.css
// module id = 1952
// module chunks = 0